module.exports = __webpack_public_path__ + "img/joinpanelist.278ac170.svg";